import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAccessToken } from "../../supabase/authService";

// Create a separate API slice for PostgreSQL backend
export const postgresApi = createApi({
  reducerPath: "postgresApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BACKEND_BASE_URL,
    prepareHeaders: async (headers) => {
      try {
        // Get the access token from Supabase auth service
        const token = await getAccessToken();

        // Set default headers
        headers.set("Content-Type", "application/json");

        // Add authorization header if token exists
        if (token) {
          headers.set("Authorization", `Bearer ${token}`);
        }

        return headers;
      } catch (error) {
        console.error("Error getting access token:", error);
        // Still set content type even if token fetch fails
        headers.set("Content-Type", "application/json");
        return headers;
      }
    },
  }),
  tagTypes: [
    "Courses",
    "MasterCourses",
    "Lessons",
    "Cards",
    "Users",
    "UserProgress",
    "UserSuggestions",
    "Certificates",
    "MasterCourses",
  ],
  // Course STRUCTURE can change underneath an open session — the 2026-07-24
  // "Leading with AI" split changed one course from 6 levels to 3 in a single DB
  // transaction, with no frontend deploy to force a reload. A subscribed RTK
  // query never refetches on its own (keepUnusedDataFor only governs UNUSED
  // data), so without these an open course page could show the pre-split shape
  // for as long as the tab stayed open. Refetching when the tab regains focus or
  // the connection returns converges those sessions within seconds of the user
  // looking at them again.
  refetchOnFocus: true,
  refetchOnReconnect: true,
  endpoints: () => ({}),
});

export const { injectEndpoints: injectPostgresEndpoints } = postgresApi;
